import { useMediaQuery } from "react-responsive";
import { Details } from "express-useragent";

type Orientation = "portrait" | "landscape";

type BPConfig = {
  "small-mobile": number;
  mobile: number;
  tablet: number;
  desktop: number;
  "big-desktop": number;
  "big-screen": number;
};

const breakpoints: BPConfig = {
  "small-mobile": 375,
  mobile: 576,
  tablet: 768,
  desktop: 1024,
  "big-desktop": 1200,
  "big-screen": 1400
};

const defaultWidth = (ua: Pick<Details, "isMobile" | "isTablet">) => {
  if (ua.isMobile && !ua.isTablet) return breakpoints.mobile;
  if (ua.isTablet) return breakpoints.tablet;
  return breakpoints.desktop;
}

export const useMediaQueryDown = (bp: keyof BPConfig, orientation?: Orientation) =>
  useMediaQuery({ maxWidth: breakpoints[bp] - 1, orientation });

export default defaultWidth;
